export const zh = {
  // Navigation & Common
  navigation: {
    dashboard: "控制台",
    quotations: "报价单", 
    projects: "项目",
    invoices: "发票",
    tasks: "任务",
    certificates: "证书",
    clients: "客户",
    users: "用户",
    templates: "模板",
    logout: "退出"
  },
  
  // Common Actions
  actions: {
    create: "创建",
    edit: "编辑", 
    delete: "删除",
    save: "保存",
    cancel: "取消",
    submit: "提交",
    search: "搜索",
    filter: "筛选",
    export: "导出",
    import: "导入",
    send: "发送",
    approve: "批准",
    reject: "拒绝",
    refresh: "刷新"
  },

  // Clients
  clients: {
    title: "客户", 
    createClient: "创建客户",
    editClient: "编辑客户",
    clientList: "客户列表",
    clientDetails: "客户详情"
  },

  // Projects  
  projects: {
    title: "项目",
    createNew: "创建新项目",
    editProject: "编辑项目",
    projectList: "项目列表",
    projectDetails: "项目详情", 
    assignedEngineer: "指定工程师",
    progress: "进度",
    startDate: "开始日期"
  },

  // Invoices
  invoices: {
    title: "发票",
    createNew: "创建新发票", 
    editInvoice: "编辑发票",
    invoiceList: "发票列表",
    invoiceNumber: "发票编号",
    issueDate: "开票日期",
    paidDate: "付款日期"
  },

  // Forms & Fields
  fields: {
    name: "姓名",
    description: "描述",
    status: "状态", 
    dueDate: "截止日期",
    createdDate: "创建日期",
    client: "客户",
    project: "项目",
    assignedTo: "分配给",
    amount: "金额",
    email: "邮箱",
    phone: "电话", 
    address: "地址"
  }
};